/**
 * The key the route-level ErrorBoundary is reset by.
 *
 * A boundary keyed by the pathname is remounted on every navigation, so a crash
 * on one page doesn't block the next. Under an installed app's mount, though,
 * the pathname changes whenever the app moves between its own screens (it
 * announces each one with `rumio:location`, and the host mirrors it), and a
 * remount there tears down the app's iframe: every in-app click reloaded the
 * whole app and lost whatever it held in memory. So everything under one mount
 * shares one key; the app handles its own navigation inside the frame.
 */
export function routeBoundaryKey(pathname: string, mountPrefixes: readonly string[]): string {
  for (const prefix of mountPrefixes) {
    const p = `/${prefix.replace(/^\/+|\/+$/g, '')}`;
    if (pathname === p || pathname.startsWith(`${p}/`)) return `mount:${p}`;
  }
  return pathname;
}
